var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{attrs:{"value":_vm.value,"options":_vm.options},on:{"input":function (e) { return _vm.$emit('update', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }